import axios from "axios";
import store from "../../../../../../stores/application/index.js.erb";

const prtfPortfolioPath = `/portfolio/api/admin/prtf_portfolios`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const PrtfAchievementApiAdminService = {

    async index(portfolioId) {
        get_token();
        try {
            return await axios.get(`${prtfPortfolioPath}/${portfolioId}/prtf_achievements`);
        } catch (e) {
            console.log("Error");
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    async show(id) {
        get_token();
        try {
            return await axios.get(`${prtfPortfolioPath}/${id}`);
        } catch (e) {
            console.log("Error");
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, попробуйте позже!",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },
}

export default PrtfAchievementApiAdminService;